import { AfterViewInit, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { UiBadgeComponent } from '@uigy/shared/components/ui-badge/ui-badge.component';
import { NgClass } from '@angular/common';
import { KpiSmallBaseComponent } from '@uigy/shared/components/widgets/kpi-small/kpi-small-base.component';
import { MatTooltip } from '@angular/material/tooltip';
import { KpiSmallRatioData } from '@uigy/modules/overview/kpis/kpi.interfaces';
import Utils from '@uigy/utils';

@Component({
    selector: 'app-ui-kpi-small-ratio',
    imports: [
        MatRipple,
        UiBadgeComponent,
        NgClass,
        MatTooltip
    ],
    templateUrl: './kpi-small-ratio.component.html',
    styleUrl: './kpi-small-ratio.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiSmallRatioComponent extends KpiSmallBaseComponent implements AfterViewInit {
  private readonly notAvailableText = this.languageService.texts.general.not_available;

  public data = input.required<KpiSmallRatioData>();
  public values = computed(() => {
    const currentValue = this.data()?.currentValue;
    const totalValue = this.data()?.totalValue;
    return this.languageService.getTranslationTyped('overview.kpi_whats_new_widgets.current_value_of_total_value', {
      currentValue: Utils.humanizeNumber(this.notAvailableText, currentValue),
      totalValue: Utils.humanizeNumber(this.notAvailableText, totalValue),
    });
  });

  constructor() {
    super();
  }

  public ngAfterViewInit(): void {
    this.isLaptopScreen.set(window.innerWidth < this.LARGE_SCREEN);
  }
}
